// extracted by mini-css-extract-plugin
module.exports = {"container":"IconButton_container__27Ktu","withoutResize":"IconButton_withoutResize__27WAb"};